export default __webpack_public_path__ + "static/media/Excellence_logo_no_background.1c00e0c7.png";